import { Action } from '@ngrx/store';

export const RatingsActionTypes = {
  GET_RATINGS: '@bidi/common-components Ratings GET_RATINGS',
  GET_RATINGS_SUCCESS: '@bidi/common-components Ratings GET_RATINGS_SUCCESS',
  GET_RATINGS_FAILURE: '@bidi/common-components Ratings GET_RATINGS_FAILURE',
  SET_RATINGS: '@bidi/common-components Ratings SET_RATINGS',
  SET_RATINGS_SUCCESS: '@bidi/common-components Ratings SET_RATINGS_SUCCESS',
};


export class GetRatings implements Action {
  readonly type = RatingsActionTypes.GET_RATINGS;

  constructor (public payload: any) {
  }
}

export class GetRatingsSuccess implements Action {
  readonly type = RatingsActionTypes.GET_RATINGS_SUCCESS;

  constructor (public payload: any) {
  }
}

export class GetRatingsFailure implements Action {
  readonly type = RatingsActionTypes.GET_RATINGS_FAILURE;

  constructor (public payload: any) {
  }
}

export class SetRatings implements Action {
  readonly type = RatingsActionTypes.SET_RATINGS;

  constructor (public payload: any) {
  }
}

export class SetRatingsSuccess implements Action {
  readonly type = RatingsActionTypes.SET_RATINGS_SUCCESS;

  constructor (public payload: any) {
  }
}
